/**
 * Projects-table aggregate for the Dashboard page.
 * 14 rows, totals 847.5h / 10,171 events.
 */

export interface DashboardProjectRow {
  name: string;
  client: string | null;
  type: 'billable' | 'general';
  hours: number;
  pct: number;
  events: number;
}

export interface DashboardProjectTotals {
  hours: number;
  events: number;
}

export const DASHBOARD_PROJECT_ROWS: readonly DashboardProjectRow[] = [
  {
    name: 'Corporate Restructuring',
    client: 'Meridian Capital',
    type: 'billable',
    hours: 156.2,
    pct: 18.4,
    events: 1874,
  },
  {
    name: 'Patent Portfolio Review',
    client: 'TechVenture Labs',
    type: 'billable',
    hours: 124.8,
    pct: 14.7,
    events: 1498,
  },
  {
    name: 'M&A Due Diligence',
    client: 'Apex Holdings',
    type: 'billable',
    hours: 98.5,
    pct: 11.6,
    events: 1182,
  },
  {
    name: 'Regulatory Compliance',
    client: 'Pinnacle Financial',
    type: 'billable',
    hours: 87.3,
    pct: 10.3,
    events: 1048,
  },
  {
    name: 'Estate Planning',
    client: 'Anderson Family Trust',
    type: 'billable',
    hours: 72.1,
    pct: 8.5,
    events: 865,
  },
  {
    name: 'Contract Negotiation',
    client: 'Stellar Dynamics',
    type: 'billable',
    hours: 45.8,
    pct: 5.4,
    events: 550,
  },
  {
    name: 'IP Licensing',
    client: 'Quantum Biotech',
    type: 'billable',
    hours: 27.3,
    pct: 3.2,
    events: 328,
  },
  {
    name: 'Internal Training',
    client: null,
    type: 'general',
    hours: 89.2,
    pct: 10.5,
    events: 1070,
  },
  {
    name: 'Firm Administration',
    client: null,
    type: 'general',
    hours: 52.4,
    pct: 6.2,
    events: 629,
  },
  {
    name: 'Pro Bono - Legal Aid',
    client: 'Community Legal',
    type: 'general',
    hours: 31.5,
    pct: 3.7,
    events: 378,
  },
  {
    name: 'IT Infrastructure',
    client: null,
    type: 'general',
    hours: 24.1,
    pct: 2.8,
    events: 289,
  },
  {
    name: 'Client Development',
    client: null,
    type: 'general',
    hours: 20.8,
    pct: 2.5,
    events: 250,
  },
  {
    name: 'Knowledge Management',
    client: null,
    type: 'general',
    hours: 12.0,
    pct: 1.4,
    events: 144,
  },
  {
    name: 'Library Research',
    client: null,
    type: 'general',
    hours: 5.5,
    pct: 0.6,
    events: 66,
  },
];

export const DASHBOARD_PROJECT_TOTALS: DashboardProjectTotals = {
  hours: 847.5,
  events: 10171,
};

export const DASHBOARD_SYNC = {
  status: 'Synced',
  lastSyncRelative: 'Last sync: 12m ago',
} as const;
